declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../../../services/hcp.service';
import { ActorSpecialtyRequest, ActorSpecialtyInfoController, ActorPrefRequest, ActorPrefsInfoController } from '../../../../../models/profileinfo/profileinfo.model';
//import { NgbSpecialtyInfoModal } from '../../Specialtyinfo/modals/Specialtyinfo.modal';
import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
//import * as moment from 'moment';
import { CustomDateTimeService } from '../../../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'EmploymentType',
  templateUrl: './employmenttype.component.html',
  styleUrls: ['./employmenttype.component.scss']
})

export class   EmploymentTypeComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  CurrentActorSpecialtyRequest: ActorPrefRequest;
  CurrentActorSpecialtyInfoController: ActorPrefsInfoController[];

  //
  CurrentActorEditSpecialtyInfoRequest: ActorPrefRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;



  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();



  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorSpecialtyRequest = new ActorPrefRequest();
    this.CurrentActorSpecialtyInfoController = new Array<ActorPrefsInfoController>();
    this.CurrentActorSpecialtyRequest.ActorCode = this.ActorCode;

    this.CurrentActorSpecialtyRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditSpecialtyInfoRequest = new ActorPrefRequest();
    this.CurrentActorEditSpecialtyInfoRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditSpecialtyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CanEdit = 1;
    this.CanShow = 1;
    if (this.CanShow === 1) {
      this.GetActorSpecialtyInfoController();
    }

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorSpecialtyRequest = null;
    this.CurrentActorSpecialtyRequest = new ActorPrefRequest();
    this.CurrentActorEditSpecialtyInfoRequest.ConditionalOperator = 1;
    this.CurrentActorSpecialtyRequest.ActorCode = this.ActorCode;
    this.CurrentActorSpecialtyRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
   

  }
  clearData() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorSpecialtyRequest = null;
    this.CurrentActorSpecialtyRequest = new ActorPrefRequest();
    this.CurrentActorEditSpecialtyInfoRequest.ConditionalOperator = 1;
    this.CurrentActorSpecialtyRequest.ActorCode = this.ActorCode;
    this.CurrentActorSpecialtyRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }



  GetActorSpecialtyInfoController() {
    this.StartRefreshing();
    this.CurrentActorSpecialtyRequest.PreferenceType = "EMPTY";
    this.CurrentActorSpecialtyRequest.ConditionalOperator = 20;
    this.hcpservice.GetActorPrefsInfoController(this.CurrentActorSpecialtyRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorSpecialtyInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit() {
    if (this.CurrentActorSpecialtyRequest.Preference.trim().length <= 0) {

      this.tosterservice.ToasterErrorAlertParam('You shall select an item from drop down list.');
      return;
    }
    
    if (this.ShowList) {

      return;
    }
    else {
   
    }
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorSpecialtyRequest.ActorPrefCode = 0;
    this.CurrentActorSpecialtyRequest.ConditionalOperator = 1;

   

    
    this.CurrentActorSpecialtyRequest.PreferenceType = "EMPTY";

    this.hcpservice.SaveActorPrefsInfo(this.CurrentActorSpecialtyRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorSpecialtyInfoController();
           // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  ShowList: boolean = true;
  CancelUpdateOperation() {
   
    this.ShowList = true;
  }
  CancelNewOperation() {
   
    this.ShowList = true;
  }
  edit_(a: any) {
    var EditCurrentActorSpecialtyInfoController: ActorPrefsInfoController = a;
    this.ShowList = false;
    this.IsExpand = true;
   
    this.CurrentActorEditSpecialtyInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditSpecialtyInfoRequest.ActorPrefCode = EditCurrentActorSpecialtyInfoController.ActorPrefCode;
    this.CurrentActorEditSpecialtyInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEditSpecialtyInfoRequest.Remarks = EditCurrentActorSpecialtyInfoController.Remarks;
    this.CurrentActorEditSpecialtyInfoRequest.Preference = EditCurrentActorSpecialtyInfoController.PreferenceTypeLongValue;
    this.CurrentActorEditSpecialtyInfoRequest.PreferenceType = EditCurrentActorSpecialtyInfoController.PreferenceTypeShortValue;

    this.isNew = false;
    this.isEdit = true;


  }
  onEditSubmit() {

  
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditSpecialtyInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditSpecialtyInfoRequest.PreferenceType = "EMPTY";
    //alert(this.CurrentActorEditSpecialtyInfoRequest.Preference);
    //alert(this.CurrentActorEditSpecialtyInfoRequest.Remarks);
    this.hcpservice.SaveActorPrefsInfo(this.CurrentActorEditSpecialtyInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorSpecialtyInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }


  del2_(EditCurrentActorSpecialtyInfoController: ActorPrefsInfoController) {
 
    this.CurrentActorEditSpecialtyInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditSpecialtyInfoRequest.ActorPrefCode = EditCurrentActorSpecialtyInfoController.ActorPrefCode;
    this.CurrentActorEditSpecialtyInfoRequest.Remarks = EditCurrentActorSpecialtyInfoController.Remarks;
 
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {


      this.CurrentActorEditSpecialtyInfoRequest.PreferenceType = "EMPTY";
      this.DeleteActorIdentities_(this.CurrentActorEditSpecialtyInfoRequest);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }

  DeleteActorIdentities_(CurrentActorEditSpecialtyInfoRequest: ActorPrefRequest) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditSpecialtyInfoRequest.ConditionalOperator = 3;
    this.CurrentActorEditSpecialtyInfoRequest.PreferenceType = "EMPTY";
    this.hcpservice.SaveActorPrefsInfo(this.CurrentActorEditSpecialtyInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetActorSpecialtyInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  del_(SpecialtyCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(SpecialtyCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(SpecialtyCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorSpecialtyRequest.ConditionalOperator = 3;
    this.CurrentActorSpecialtyRequest.ActorPrefCode = SpecialtyCode;
    this.hcpservice.SaveActorPrefsInfo(this.CurrentActorSpecialtyRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetActorSpecialtyInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }






  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



}
